import { Controller } from "@hotwired/stimulus"

// AB-067 — All / Boosted / Not Boosted filter for the Eligible Posts grid.
// Pure client-side, mirroring history_filter_controller: toggles each
// tile's `hidden` class by matching its data-boosted ("true"/"false")
// against the active chip. The grid is already fully loaded (≤50 posts),
// so there is no fetch / debounce / pagination.
export default class extends Controller {
  static targets = ["tile", "chip", "empty"]

  connect() {
    console.log(`[eligible-posts-filter] connect tiles=${this.tileTargets.length} chips=${this.chipTargets.length}`)
    this.status = "all"
  }

  chooseStatus(event) {
    const chip = event.currentTarget
    this.status = chip.dataset.status || "all"
    // Set the active chip to data-active="true" (not a bare boolean attribute):
    // the chip styling keys off `data-[active=true]` → CSS [data-active="true"],
    // which toggleAttribute's empty value would never match.
    this.chipTargets.forEach((c) => {
      if (c === chip) {
        c.setAttribute("data-active", "true")
      } else {
        c.removeAttribute("data-active")
      }
    })
    this.applyFilters()
  }

  applyFilters() {
    let visible = 0
    this.tileTargets.forEach((tile) => {
      const boosted = tile.dataset.boosted === "true"
      const match =
        this.status === "all" ||
        (this.status === "boosted" && boosted) ||
        (this.status === "unboosted" && !boosted)
      tile.classList.toggle("hidden", !match)
      if (match) visible += 1
    })
    console.log(`[eligible-posts-filter] status=${this.status} visible=${visible}/${this.tileTargets.length}`)
    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visible > 0)
    }
  }
}
